// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const app = angular.module('landingPage');

window.webglSupport = function () {
  try {
    const canvas = document.createElement('canvas');
    return (
      !!window.WebGLRenderingContext &&
      (canvas.getContext('webgl') || canvas.getContext('experimental-webgl'))
    );
  } catch (e) {
    return false;
  }
};

app.directive('giVrVideo', ($document) => ({
  link(scope, elem, attr) {
    if (window.webglSupport()) {
      if (isMobile) {
        const iframe = $('<iframe>', {
          allowfullscreen: '',
          frameborder: '0',
          src: '/third-party/vrview/vrview.html?image=' + attr['fallbackImage'],
        });
        $(elem).replaceWith(iframe);
        return setTimeout(function () {
          const idoc = $($('.vr-container iframe')[0].contentDocument);
          return idoc
            .find('.webvr-button')
            .on('click', () =>
              $(document).trigger('track.landing.vrFullscreenClick')
            );
        }, 1000);
      } else {
        window.pannellumConfig = {
          type: 'equirectangular',
          dynamic: true,
          showZoomCtrl: true,
          showFullscreenCtrl: true,
          autoLoad: true,
          hfov: 120,
          autoRotate: -0.25,
        };
        const video = $('<video>', {
          id: 'panorama-video',
          class: 'video-js vjs-default-skin vjs-big-play-centered',
          crossorigin: 'anonymous',
          autoplay: '',
          loop: '',
          muted: '',
          preload: 'none',
        });
        video.append(
          $('<source>', {
            src: attr['giVrVideo'],
            type: 'video/mp4',
          })
        );
        $(elem).append(video);
        videojs('panorama-video', { plugins: { pannellum: {} } });

        const fullscreenHandler = function () {
          if (
            document.webkitIsFullScreen ||
            document.mozFullScreen ||
            document.msFullscreenElement !== undefined
          ) {
            return $(document).trigger('track.landing.vrFullscreenClick');
          }
        };
        $(document).on('webkitfullscreenchange', fullscreenHandler);
        $(document).on('mozfullscreenchange', fullscreenHandler);
        $(document).on('fullscreenchange', fullscreenHandler);
        return $(document).on('MSFullscreenChange', fullscreenHandler);
      }
    } else {
      const img = $('<img>', {
        class: 'vr-fallback',
        src: attr['fallbackImage'],
      });
      return $(elem).append(img);
    }
  },
}));
